

//#StemsAccountsDev: focus input when anything inside is clicked
$(function () {
    $(".widget-text-input").each(function (idx, element) {
        var $input = $(element).children("input");
        var $icon = $(element).children("span.fas");
        var $label = $(element).children("label");

        var _processInput = function (input) {
            var value = $(input).val();

            $(input).parent().removeClass("focused");
            $(input).parents(".widget-calendar").removeClass("focused");

            if (!value) {
                $(input).parent().removeClass("populated");
            }
            else {
                $(input).parent().addClass("populated");
            }
        };

        $input.focus(function () {
            var isreadonly = $(this).prop("readonly");

            if (!isreadonly) {
                $(this).parent().addClass("populated")
                    .addClass("focused");
                $(this).parents(".widget-calendar")
                    .addClass("focused");
            }
        });

        $input.change(function () {
            _processInput(this);
        })

        $input.blur(function () {
            _processInput(this);
        });

        if ($input.length > 0)
            _processInput($input.get(0));
    })
})